import PropTypes from 'prop-types';
import React from 'react';
import styled, {css} from 'styled-components';
import {Sidebar as SemanticSidebar} from 'semantic-ui-react';
import {FullViewContainer} from '../Container/ContainerMix';

const StyledSemanticSidebarPushable = styled(SemanticSidebar.Pushable)`
  overflow: hidden;
  // this is a nutty fix to overried the z-index, should look at this later for a better solution
  .ui.overlay.sidebar {
    z-index: 1002;
  }
`;

const Menu = styled.div`
  background-color: #ffffff;
  overflow: hidden;
  width: calc(100vw - 20%) !important;
  @media (min-width: 568px) {
    width: calc(100vw - 25%) !important;
  }
`;

const StyledSemanticSidebarPusher = styled(SemanticSidebar.Pusher)`
  height: calc(100vh);
  position: unset !important;
  &::after {
    position: absolute;
    position: fixed;
    top: 0;
    right: 0;
    content: '';
    background-color: rgba(0,0,0,.4);
    overflow: hidden;
    opacity: 0;
    transition: opacity .5s;
    will-change: opacity;
    z-index: 1000;
    ${props => props.dimmed && css`
      width: 100%!important;
      height: 100%!important;
      opacity: 1!important;
    `}
  }
`;

const Sidebar = ({children, isVisible, onHide, menuItems}) => (
  <StyledSemanticSidebarPushable as={FullViewContainer}>
    <SemanticSidebar
      as={Menu}
      animation="overlay"
      onHide={onHide}
      vertical
      visible={isVisible}
    >
      {menuItems}
    </SemanticSidebar>

    <StyledSemanticSidebarPusher className="StyledSemanticSidebarPusher" dimmed={isVisible}>{children}</StyledSemanticSidebarPusher>
  </StyledSemanticSidebarPushable>
);

Sidebar.propTypes = {
  children: PropTypes.any.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  menuItems: PropTypes.element.isRequired
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js